<form role="form" class="form-horizontal">
	<div class="form-group">
		<label class="control-label col-md-1 plus-half">D&eacute;but&nbsp;:</label>
		<div class="col-md-2 plus-half">
			<date-input
				[id]="'inputFiltreDate'"
				(localDateChange)="filters.date = $event"
				>
			</date-input>
		</div>
		<label class="control-label col-md-1 plus-half">Type&nbsp;:</label>
		<div class="col-md-2 plus-half">
			<select id="typeCritere" name="typeCritere" class="form-control" [(ngModel)]="filters.jobName" >
				<option [ngValue]="null"></option>
				<option *ngFor="let jobName of jobNames"
					 [ngValue]="jobName"
				>
					{{ jobName }}
				</option>
			</select>
		</div>
	</div>
	<div class="form-group">
		<div class="col-sm-6 text-center">
			<button type="button" class="btn btn-success" (click)="search()">Filtrer</button>
		</div>
		<div class="col-sm-6 text-center">
			<button type="button" class="btn btn-primary" (click)="resetFilters()">R&eacute;initialiser</button>
		</div>
	</div>
</form>